module.exports = __webpack_public_path__ + "joy-static/media/RotateArt.b104d218.png";